<div *ngIf="!loading">
  <div style="text-align:left">
    <h2 style=" margin-top: 0px; color: black;
    margin-bottom: 11px;">Duplicate file detected</h2>
    <mat-divider [inset]="false" class="matlist-divider"></mat-divider>
    <div style="margin-top: 13px;" class="primary-color">A file <strong>{{filename}}</strong> already exists in
      <strong>{{sitename}}</strong>.</div>
    <div  class="primary-color">Would you like to:</div>
    <div>
      <mat-radio-group class="radio-group">

        <ng-container *ngFor="let item of fileOptions">

            <mat-radio-button class="radioMargTop0" aria-label="Select {{item.value}}" 
              [value]="item" (click)="enableUploadButton(item.key)">
              {{item.value}}
            </mat-radio-button>

        </ng-container>
      </mat-radio-group>
    </div>
  </div>
</div>